var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImagePopupFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3677 8.26793C11.8141 8.22593 12.266 8.39704 12.6666 8.78281L14.9999 11.1161",
    stroke: "#387EE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 4.89062H10.3412",
    stroke: "#387EE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11109 1H12.6666C13.2854 1 13.8789 1.24583 14.3165 1.68341C14.7541 2.12099 14.9999 2.71448 14.9999 3.33332V11.8888M14.3341 14.2991C14.117 14.5214 13.8577 14.6979 13.5713 14.8182C13.2849 14.9386 12.9772 15.0004 12.6666 14.9999H3.33332C2.71448 14.9999 2.12099 14.7541 1.68341 14.3165C1.24583 13.8789 1 13.2854 1 12.6666V3.33332C1 2.6761 1.27144 2.08266 1.70777 1.65877",
    stroke: "#387EE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.1129L4.88886 7.22404C5.61063 6.52949 6.50041 6.52949 7.22218 7.22404L11.111 11.1129",
    stroke: "#387EE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImagePopupFound);
export default __webpack_public_path__ + "static/media/noImagePopupFound.f9bc7c3b375893c7fe20a6148d3678d2.svg";
export { ForwardRef as ReactComponent };